<template>
    <div class="boxControll">
        <div class="bodyControll">
            <div class="them">2020版造价计价标准宣贯学习</div>
            <div class="infoControll">
                <div class="info" @click="noticeVisible = true">报名须知&nbsp;&nbsp;&nbsp;&nbsp;></div>
            </div>
            <!--            <div class="helpBtn">-->
            <!--                <div class="blueBtn btn">用户登录</div>-->
            <!--                <div class="whiteBtn btn">账号注册</div>-->
            <!--            </div>-->

            <!--登录-->
            <div class="cont">
                <div
                    class="ms-title"
                    style="font-size: 14px; color: #666; margin-bottom: 40px; cursor: pointer; display: flex; justify-content: center"
                >
                    <div class="headImg"></div>
                    <span
                        :class="{ selected: loginStyle == 1 }"
                        @click="loginStyle = 1"
                        style="min-width:70px;font-size: 16px; text-align: center; font-weight:bold;border-bottom: #fff solid 3px; padding-bottom: 9px"
                        >个人登录</span
                    >

                    <span
                        :class="{ selected: loginStyle == 2 }"
                        @click="loginStyle = 2"
                        style="min-width: 70px; font-size: 16px;text-align: center; font-weight:bold;margin-left: 80px; border-bottom: #fff solid 3px; padding-bottom: 9px"
                        >企业登录</span
                    >
                </div>
                <!-- 个人登录 -->
                <div v-if="loginStyle == 1">
                    <el-form :model="loginForm" :rules="rules" ref="login" label-width="0px" class="ms-content">
                        <el-form-item prop="account">
                            <el-input v-model="loginForm.account" placeholder="请输入身份证进行登录">
                                <el-button
                                    slot="prepend"
                                    style="width: 15px; height: 15px;background-size: 100% 100%;"
                                    class="styleImg userImg"
                                ></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                                type="password"
                                placeholder="请输入密码"
                                v-model="loginForm.password"
                                @keyup.enter.native="submitForm()"
                            >
                                <el-button slot="prepend" style="width: 15px; height: 15px" class="styleImg keyImg"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 企业登录 -->
                <div v-if="loginStyle == 2">
                    <el-form :model="loginForm" :rules="rules" ref="login" label-width="0px" class="ms-content">
                        <el-form-item prop="confirm_code">
                            <el-input v-model="loginForm.confirm_code" placeholder="请输入企业纳税号进行登录">
                                <el-button
                                    slot="prepend"
                                    style="width: 15px; height: 15px;background-size: 100% 100%;"
                                    class="styleImg userImg"
                                ></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="confirm_psd">
                            <el-input type="password" placeholder="请输入密码" v-model="loginForm.confirm_psd">
                                <el-button
                                    slot="prepend"
                                    style="width: 15px; height: 15px;background-size: 100% 100%;"
                                    class="styleImg keyImg"
                                ></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="helpBox">
                    <div class="login-tips" @click="registerDialog = true">注册账号</div>
                    <div class="forget" @click="forgetDialog = true">找回密码</div>
                </div>
                <div class="login-btn">
                    <el-button type="primary" @click="login">登录</el-button>
                </div>
                <div class="loginRemark">
                    <div class="tip">温馨提示：</div>
                    <div class="tip_letter" style="margin-top:10px;">
                        1、注册过二级造价师管理的用户可以直接用原账户密码进行登录报名、学习。
                    </div>
                    <div class="tip_letter">2、企业批量报名学员账号为：身份证号码，默认密码为：身份证号后8位。</div>
                    <div class="tip_letter">注意 : 默认密码全为大写，身份证号最后一位若为x，则默认密码最后一位为大写X</div>
                    <div class="tip_letter">3、报名服务咨询电话 0871-68184040</div>
                </div>
            </div>
            <!--登录完-->
            <div class="footer">
                主办单位：云南省工程建设技术经济室
                <div class="space"></div>
                电话：0871-68184040<br />
                技术支持：昆明行列科技有限公司
                <div class="space"></div>
                <br />
                备案号：<a
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index"
                target='_blank'
                style="text-decoration: none; color: #fff"
            >滇ICP备18001273号-1</a>
                <a
                    href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index"
                    style="text-decoration: none; color: #fff"
                    target='_blank'
                >备案号：滇ICP备18001273号-1</a>
            </div>
        </div>
        <!--企业忘记密码-->
        <CompanyReset
            :is_style="is_style"
            :companycode="companycode"
            v-if="CompanyResetDialog"
            :CompanyResetDialog.sync="CompanyResetDialog"
            :companyMobile="companyMobile"
            @companyDialog="companyDialog"
        />
        <!--个人忘记密码-->
        <PersonalReset
            :is_style="is_style"
            :idcard="idcard"
            :personalMobile="personalMobile"
            v-if="PersonalResetDialog"
            @PersonalSwitch="PersonalSwitch"
            :PersonalResetDialog.sync="PersonalResetDialog"
        />
        <!-- 注册 -->
        <Register v-if="registerDialog" :registerDialog.sync="registerDialog"></Register>
        <!-- 忘记密码 -->
        <Forget
            :title="loginStyle"
            v-if="forgetDialog"
            :forgetDialog.sync="forgetDialog"
            :companyMobile.sync="companyMobile"
            :personalMobile.sync="personalMobile"
            @regSwitch="regSwitch"
            @companySwitch="companySwitch"
        ></Forget>
        <div class="noticeBox">
            <el-dialog title="报名须知" :visible.sync="noticeVisible" width="50%" @close="handleClose">
                <Notice />
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="noticeVisible = false" class="confirmBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import Register from '@/components/Register';
import Notice from '@/components/Notice';
import Forget from '@/components/Forget';
import PersonalReset from '@/components/PersonalReset';
import CompanyReset from '@/components/CompanyReset';
import user from '@/api/user';
import enter from '@/api/enter';
export default {
    components: {
        Register,
        Forget,
        Notice,
        PersonalReset,
        CompanyReset
    },
    data: function() {
        return {
            companycode: '', //统一信用代码
            idcard: '', //身份证
            is_style: false,
            PersonalResetDialog: false,
            CompanyResetDialog: false,
            loginStyle: 1,
            registerDialog: false, //控制注册框显示
            forgetDialog: false, //控制忘记密码框显示
            personalMobile: '', //个人电话号码
            companyMobile: '', //公司电话号码
            noticeVisible: false, //报名须知
            loginForm: {
                account: '', //个人账户
                password: '', //个人密码
                confirm_code: '', //企业纳税号
                confirm_psd: '' //企业密码
            },
            rules: {
                account: [{ required: true, message: '请输入身份证进行登录', trigger: 'blur' }],
                password: [{ required: true, message: '请输入个人密码', trigger: 'blur' }],
                confirm_code: [{ required: true, message: '请输入企业纳税号进行登录', trigger: 'blur' }],
                confirm_psd: [{ required: true, message: '请输入企业密码', trigger: 'blur' }]
            }
        };
    },
    watch: {
        loginStyle(val) {
            this.$refs.login.resetFields();
        }
    },
    mounted() {
        this.$store.dispatch('get_user');
    },
    methods: {
        login() {
            if (this.loginStyle == 1) {
                this.accountLogin();
            } else {
                this.enterLogin();
            }
        },

        // 个人登录
        accountLogin() {
            if (!this.loginForm.account || !this.loginForm.password) {
                this.$message.error('请填写用户名和密码');
                return false;
            }

            user.login(this.loginForm.account, this.loginForm.password)
                .then(res => {
                    console.log(res);
                    // location.href = 'http://localhost:8081/#/dashboard/train/index?token=' + res.data.ejtoken;
                    if (res.data.ejtoken) {
                        //正式
                        location.href = 'http://tsm.ynbzde.com/#/dashboard/train/index?token=' + res.data.ejtoken;
                        //测试
                        // location.href = 'http://erzjs.jc881.com/#/dashboard/train/index?token=' + res.data.ejtoken;
                        // return;
                    } else {
                        this.$message.error('登录失败， 请刷新页面重试');
                    }
                })
                .catch(err => {
                    if (err.code == 0) {
                        this.$message.error(err.msg);
                    } else if (typeof err == 'string') {
                        this.$message.error(err);
                    } else {
                        this.$message.error('发生异常情况， 请联系管理人员');
                        console.log(err);
                    }
                });
        },

        // 企业登录
        enterLogin() {
            if (!this.loginForm.confirm_code || !this.loginForm.confirm_psd) {
                this.$message.error('请填写企业纳税号和密码');
                return false;
            }

            enter
                .login(this.loginForm.confirm_code, this.loginForm.confirm_psd)
                .then(res => {
                    let data = res.data.userinfo;
                    this.$store.dispatch('set_enter', data);
                    this.$router.push('/home/company');
                })
                .catch(err => {
                    if (err.code == 0) {
                        this.$message.error(err.msg);
                    } else if (typeof err == 'string') {
                        this.$message.error(err);
                    } else {
                        this.$message.error('发生异常情况， 请联系管理人员');
                        console.log(err);
                    }
                });
        },
        regSwitch(idcard) {
            this.idcard = idcard.idcard || '';
            this.forgetDialog = false;
            // this.registerDialog = true;
            this.is_style = true;
            this.PersonalResetDialog = true;
        },
        companySwitch(companycode) {
            this.companycode = companycode.companycode || '';
            console.log(this.companycode);
            this.forgetDialog = false;
            // this.registerDialog = true;
            this.is_style = false;
            this.CompanyResetDialog = true;
            console.log(this.CompanyResetDialog);
        },
        PersonalSwitch() {
            console.log(12312312);
            this.PersonalResetDialog = false;
        },
        companyDialog() {
            this.CompanyResetDialog = false;
        },
        //关闭弹窗
        handleClose() {
            this.dialogVisible = false;
        }
    }
};
</script>

<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
}
.boxControll {
    height: 100vh;
    .bodyControll {
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('~@/assets/img/bg.jpg');
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        padding-top: 8%;
        .them {
            justify-content: center;
            display: flex;
            color: #ffffff;
            font-size: 32px;
            font-weight: 500;
        }
        .infoControll {
            display: flex;
            justify-content: center;
            .info {
                margin: auto;
                color: #fdd30d;
                cursor: pointer;
                margin-top: 10px;
                font-size: 14px;
            }
        }
    }
    .cont {
        background-color: #fff;
        width: 600px;
        height: 450px;
        padding: 37px 70px;
        box-sizing: border-box;
        margin: auto;
        margin-top: 45px;
        display: block;
        color: #606266;
        font-size: 14px;
        .styleImg {
            width: 15px;
            height: 15px;
            background-repeat: no-repeat;
            position: absolute;
            left: 34px;
            top: 17px;
            background-size: 100% 100%;
        }
        .keyImg {
            background-image: url('~@/assets/img/key1.png');
        }
        .userImg {
            background-image: url('~@/assets/img/personal.png');
        }
        .selected {
            color: #1890ff;
            border-bottom: solid 3px #1890ff !important;
        }
        .helpBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 22px;

            div {
                font-size: 14px;
                cursor: pointer;
                color: #1890ff;
                transition: all 0.2s;

                &:hover {
                    color: #33b3f3;
                }
            }
        }
        .login-btn {
            /deep/ .el-button--small {
                font-size: 12px !important;
                border-radius: 3px !important;
                width: 100% !important;
                letter-spacing: 5px;
                text-indent: 5px;
                cursor: pointer;
                transition: all 0.2s;
                background: #1890ff;
                color: #ffffff;
                height: 32px;
                font-size: 14px;
                -webkit-transition: all 0.2s;
                border: 1px solid #1890ff;
                &:hover {
                    background: #409eff;
                    color: #fff;
                }
            }
        }
        .loginRemark {
            margin-top: 20px;
            .tip {
                color: #fd7e0d;
                font-size: 14px;
            }
            .tip_letter {
                font-size: 12px;
                color: #666;
                line-height: 20px;
            }
        }
    }
    .footer {
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        line-height: 20px;
        margin-top: 100px;
        text-align: center;
        padding-bottom: 40px;
        margin-top: 44px;
        .space {
            display: inline-block;
            width: 10px;
        }
    }
    .noticeBox {
        /deep/ .el-dialog__footer {
            padding: 20px 0px;
            display: flex;
            justify-content: center;
        }
        .confirmBtn {
            padding: 10px 30px;
        }
        /deep/ .el-dialog__header {
            padding: 20px 20px 10px;
            justify-content: center;
            display: flex;
        }
        /deep/ .el-dialog__body {
            padding: 0px 20px !important;
        }
    }
}
</style>
